import {createReducer, Reducer} from "redux-act";
import {ISquadReducer} from "modules/types";
import {fetchSquadsSuccessAction} from "modules/actions/jsons";

const initialState: ISquadReducer = [];
export const squads: Reducer<ISquadReducer> = createReducer({}, initialState);
squads.on(fetchSquadsSuccessAction, (state, payload) => payload);
